import React, { useState, useEffect } from 'react';
import HeadingArea from '../../general/HeadingArea';
import { AiOutlineSearch } from 'react-icons/ai';
import { FaCheck } from 'react-icons/fa';
import ResponseMsg2 from '../../general/ResponseMsg2';

const StudentAttendance = ({ setLoading }) => {
  const [classes, setClasses] = useState([]);
  const [std, setStd] = useState([]);
  const [availableSections, setAvailableSections] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
const [selectedDate, setSelectedDate] = useState('');
const [attendanceData, setAttendanceData] = useState({});
    const [response2, setResponse2] = useState({ message: '', status: 'success' });
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedAY, setSelectedAY] = useState('');
  const [showMark, setShowMark] = useState(false);
const [searchTerm, setSearchTerm] = useState('');


  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');
      if (response.ok) {
        const data = await response.json();
        setClasses(data);
      } else {
        console.error('Failed to fetch class');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAcademicYears = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-academic-years');
      if (response.ok) {
        const data = await response.json();
        const sortedData = data.sort((a, b) => b.id - a.id);
        setAcademicYears(sortedData);
      } else {
        console.error('Failed to fetch academic years');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  // Initial fetches for classes and academic years
  useEffect(() => {
    fetchClasses();
    fetchAcademicYears();
  }, []);

  useEffect(() => {
    if (selectedClassId) {
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      if (selectedClass && selectedClass.sections) {
        const sectionArray = selectedClass.sections
          .split(',')
          .map((s) => s.trim())
          .filter((s) => s !== '');
        setAvailableSections(sectionArray);
      } else {
        setAvailableSections([]);
      }
      setSelectedSection('');
    } else {
      setAvailableSections([]);
      setSelectedSection('');
    }
  }, [selectedClassId, classes]);

  // New: Search function to fetch filtered students
  const handleSearch = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {

      const currentYear = new Date().getFullYear();

      // Get class_name from classId
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      const className = selectedClass ? selectedClass.class_name : '';

      // Build query params
      const params = new URLSearchParams();
      params.append('ay', selectedAY);
      params.append('class_name', className);

      if (selectedSection) {
        params.append('section', selectedSection);
      }

      const url = `https://api.kcian.in/get-student?${params.toString()}`;

      const response = await fetch(url);

      if (response.ok) {
        const data = await response.json();
        setStd(data);
         const defaultAttendance = {};
  data.forEach((student) => {
    defaultAttendance[student.id] = {
      attendance: 'Present',
      note: ''
    };
  });
  setAttendanceData(defaultAttendance);
      } else {
        console.error('Failed to fetch students');
      }
    } catch (error) {
      console.error('Error fetching students:', error);
    } finally {
      setLoading(false);
    }
  };


  const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
const selectedClassName = selectedClass ? selectedClass.class_name : '';


const handleSaveAttendance = async (markHoliday = null) => {

  const monthName = new Date(selectedDate).toLocaleString('default', { month: 'long' });

  const payload = std.map((student) => ({
    studentId: student.id,
    class_name: selectedClassName,
    section: selectedSection,
    date: selectedDate,
    month: monthName,
    mark: markHoliday ? markHoliday : attendanceData[student.id]?.attendance || '',
    note: markHoliday ? markHoliday : attendanceData[student.id]?.note || '',
    ay: selectedAY
  }));

  setLoading(true);
  try {
    const response = await fetch('https://api.kcian.in/save-attendance', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ records: payload }),
    });

    if (response.ok) {
        setResponse2({ message: 'Attendance saved successfully!', status: 'success' });
        setShowMark(false);
        setTimeout(() => {
          setResponse2('');
        }, 2000);
      // Optionally reset form or show a success message
    } else {
                 setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 2000);
    }
  } catch (error) {
    console.error('Error saving attendance:', error);
  } finally {
    setLoading(false);
  }
};


 const filteredStd = std.filter((cls) => {
  const term = searchTerm.toLowerCase();

  return (
    String(cls.roll_no || '').toLowerCase().includes(term) ||
    String(cls.name || '').toLowerCase().includes(term)
  );
});

  return (
    <>
      <section className='py-4'>
        <div className='px-4'>
          <HeadingArea message1='Attendance' message2='Student Attendance' />

          <form onSubmit={handleSearch} className='profile-card'>
            <span className="profile-heading">Select Criteria</span>

            <div className='row mt-3'>

              <div className="col-lg-3 col-md-6 col-6 mb-4">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select AY*</label>
                  <select
                    className="profile-input"
                    value={selectedAY}
                    onChange={(e) => setSelectedAY(e.target.value)}
                    required
                  >
                    <option value="">-- Select Academic Year --</option>
                    {academicYears.map((ay) => (
                      <option key={ay.year} value={ay.year}>
                        {ay.year} --- {ay.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>


              <div className="col-lg-3 col-md-6 col-6 mb-4">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Class*</label>
                  <select
                    className="profile-input"
                    value={selectedClassId}
                    onChange={(e) => setSelectedClassId(e.target.value)}
                    required
                  >
                    <option value="">-- Select Class --</option>
                    {classes.map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-6 mb-4">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Section*</label>
                  <select
                    className="profile-input"
                    value={selectedSection}
                    onChange={(e) => setSelectedSection(e.target.value)}
                    disabled={availableSections.length === 0}
                    required
                  >
                    <option value="">-- Select Section --</option>
                    {availableSections.map((section, idx) => (
                      <option key={idx} value={section}>
                        {section}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-6 mb-4">
  <div className='profile-input-area'>
    <label className="profile-badge">Select Date*</label>
    <input 
      type="date" 
      className="profile-input" 
      value={selectedDate} 
      onChange={(e) => setSelectedDate(e.target.value)} 
      required
    />
  </div>
</div>


            </div>
{/* flex ends */}


            <div className='text-end'>
              <button type='submit' className='profile-btn2'>
                <AiOutlineSearch /> Search
              </button>
            </div>
          </form>


          <div className='profile-card mt-3'>
            <span className="profile-heading">Class: {selectedClassName}, Section: {selectedSection}, Date: {selectedDate}</span>
            {/* Render student list here */}

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

<br />

{filteredStd.length != 0 && 
<div className='d-md-flex justify-content-between'>
{!showMark && <button className='profile-btn mt-2' onClick={() => setShowMark(true)}>Mark Holiday</button>}
{showMark && (
<div className='d-block'>
<p className='fw-semibold mt-2'>Want to mark Today as Holiday?</p>
            <button className='profile-btn me-2' onClick={() => handleSaveAttendance('Holiday')}>Yes</button>
            <button className='profile-btn2' onClick={() => setShowMark(false)}>No</button>
</div>
)}
  <div className='profile-input-area ms-auto col-lg-3 border-0'>
<input
  type='text'
  name='search'
  className='profile-input border-bottom rounded-0'
  placeholder='Search by Roll no, Name'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>
</div>
</div>

}

            <div className='table-responsive my-3'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Roll No</th>
    <th>Name</th>
    <th>Reg No</th>
    <th>Attendance</th>
    <th className='rounded-end-4'>Note</th>
</thead>

            {filteredStd.length === 0 ? (
              <tr className='text-center account-tr'><td colSpan={8}>No Student Data found</td></tr>
            ) : (
              <>
                {filteredStd.map((student) => (
  <tr className='account-tr' key={student.id}>
    <td>{student.roll_no}</td>
    <td>{student.name}</td>
    <td>{student.reg_no}</td>
<td>
  <div className='d-flex gap-2'>
    {['Present', 'Absent', 'Leave'].map((status) => (
      <label key={status}>
        <input
          type="radio"
          name={`attendance-${student.id}`}
          value={status}
          checked={attendanceData[student.id]?.attendance === status}
          onChange={() =>
            setAttendanceData((prev) => ({
              ...prev,
              [student.id]: {
                ...prev[student.id],
                attendance: status,
              },
            }))
          }
        />{' '}
        {status}
      </label>
    ))}
  </div>
</td>

<td>
              <div className='profile-input-area'>
  <input
    type="text"
    placeholder="Add Note Here"
    className="profile-input"
    value={attendanceData[student.id]?.note || ''}
    onChange={(e) =>
      setAttendanceData((prev) => ({
        ...prev,
        [student.id]: {
          ...prev[student.id],
          note: e.target.value,
        },
      }))
    }
  />
  </div>
</td>
                    </tr>
                ))}
              </>
            )}
</table>
</div>

<div className='text-center'>
<button className='profile-btn' onClick={() => handleSaveAttendance(null)}>
  <FaCheck /> Save Attendance
</button></div>

</div>


        </div>
      </section>


    </>
  );
};

export default StudentAttendance;
